import { AxiosResponse } from 'axios'

import { _axios } from 'hooks/api/axios'

const SECURITY_CSV_IMPORT = (branchId: string) =>
  `/cls1/company-branches/${branchId}/securities/csv`
const SECURITY_FIELD_CSV_IMPORT = (branchId: string) =>
  `/cls1/company-branches/${branchId}/security-fields/csv`

export const cls1Api = () => {
  const securityCsvImport = async (
    branchId: string,
    formData: FormData,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(SECURITY_CSV_IMPORT(branchId), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  const securityFieldCsvImport = async (
    branchId: string,
    formData: FormData,
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(SECURITY_FIELD_CSV_IMPORT(branchId), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  return {
    securityCsvImport,
    securityFieldCsvImport,
  }
}
